export function objectIncludeSome<T>(obj: T, keys: (keyof T)[]): boolean {
  return keys.some((key) => obj[key] != undefined);
}
